const MIN_AREA_DIVIDER = 2
const MAX_AREA_MULTIPLIER = 2

module.exports = {
  MIN_AREA_DIVIDER,
  MAX_AREA_MULTIPLIER
}